import { NOTIFICATION_BAR_STATE_ERROR, NOTIFICATION_BAR_STATE_SUCCESS, NOTIFICATION_BAR_STATE_WARNING } from '@/constants';
import { INotification } from '@/features/common/types';
import info from '@/assets/info.svg';
import error from '@/assets/error.svg';

export const createNotificationHelpers = () => {
    const getSuccessNotification = (message: string) =>
        ({
            show: true,
            message: message,
            color: NOTIFICATION_BAR_STATE_SUCCESS.BG,
            border: NOTIFICATION_BAR_STATE_SUCCESS.BORDER
        }) as INotification;

    const getErrorNotification = (message: string) =>
        ({
            show: true,
            message: message,
            icon: error,
            color: NOTIFICATION_BAR_STATE_ERROR.BG,
            border: NOTIFICATION_BAR_STATE_ERROR.BORDER
        }) as INotification;

    const getWarningNotification = (message: string) =>
        ({
            show: true,
            message: message,
            icon: info,
            color: NOTIFICATION_BAR_STATE_WARNING.BG,
            border: NOTIFICATION_BAR_STATE_WARNING.BORDER
        }) as INotification;

    const getHiddenNotification = () =>
        ({
            show: false,
            message: '',
            color: NOTIFICATION_BAR_STATE_SUCCESS.BG,
            border: NOTIFICATION_BAR_STATE_SUCCESS.BORDER
        }) as INotification;

    return {
        notificationSuccess: (message: string) => getSuccessNotification(message),
        notificationError: (message: string) => getErrorNotification(message),
        notificationWarning: (message: string) => getWarningNotification(message),
        notificationHide: () => getHiddenNotification()
    };
};
